import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config/api';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('wbla_token'));
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (token) {
      axios.get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(() => setIsAdmin(true))
        .catch(() => { setToken(null); localStorage.removeItem('wbla_token'); });
    }
  }, [token]);

  const login = async (username, password) => {
    const res = await axios.post(`${API}/admin/login`, { username, password });
    const newToken = res.data.access_token;
    localStorage.setItem('wbla_token', newToken);
    setToken(newToken);
    setIsAdmin(true);
    return true;
  };

  const logout = () => {
    localStorage.removeItem('wbla_token');
    setToken(null);
    setIsAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ token, isAdmin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
